import { render, staticRenderFns } from "./coupon-detail.vue?vue&type=template&id=7ecdd63c&scoped=true"
import script from "./coupon-detail.vue?vue&type=script&lang=js"
export * from "./coupon-detail.vue?vue&type=script&lang=js"
import style0 from "./coupon-detail.vue?vue&type=style&index=0&id=7ecdd63c&prod&scoped=true&lang=css"
import style1 from "./coupon-detail.vue?vue&type=style&index=1&id=7ecdd63c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecdd63c",
  null
  
)

export default component.exports